<div class="modal-header d-flex  justify-content-between">
    <h5 class="modal-title">Videresend event</h5>

    <button (click)="modal.close()" type="button" class="btn btn-sm btn-danger" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <form (ngSubmit)="onSubmit()" #loginForm="ngForm" novalidate>
        <div class="mb-3">
            <label for="email" i18n>Email</label>
            <input type="email" class="form-control" id="email"
                   [(ngModel)]="data.email" name="email"
            >
        </div>
        <div class="mb-3">
            <label for="phone" i18n>Mobil</label>
            <input type="number" class="form-control" id="phone"
                   [(ngModel)]="data.phone" name="phone"
            >
        </div>
        <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-success" [disabled]="!loginForm.form.valid || submitted">
                <i class="fas fa-circle-notch fa-spin" *ngIf="submitted" style="margin-right: 0.5em"></i>
                Send
            </button>
        </div>
    </form>
</div>

<div class="modal-footer">
</div>
